// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const ImportFlow = registerClientReference(
    function() { throw new Error("Attempted to call ImportFlow() from the server but ImportFlow is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/(admin)/report-templates/_components/import-flow.tsx",
    "ImportFlow",
);
